module.exports = __webpack_public_path__ + "components/no-js-bar/static/exclamation-mark-f25fcafbc362aaa6db58eb99b663c743.svg";